import { render, staticRenderFns } from "./LiteConfiguratorPage.vue?vue&type=template&id=50934ca4&scoped=true&"
import script from "./LiteConfiguratorPage.vue?vue&type=script&lang=js&"
export * from "./LiteConfiguratorPage.vue?vue&type=script&lang=js&"
import style0 from "./LiteConfiguratorPage.vue?vue&type=style&index=0&id=50934ca4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50934ca4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50934ca4')) {
      api.createRecord('50934ca4', component.options)
    } else {
      api.reload('50934ca4', component.options)
    }
    module.hot.accept("./LiteConfiguratorPage.vue?vue&type=template&id=50934ca4&scoped=true&", function () {
      api.rerender('50934ca4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/LiteConfiguratorPage.vue"
export default component.exports